module.exports = __webpack_public_path__ + "img/22_71.8d3917a3.png";